import { Component, HostListener, ViewChild } from '@angular/core';
import Quill from 'quill';
import { UtilService } from './services/util.service';
import * as introJs from 'intro.js/intro.js';
import { DomSanitizer } from '@angular/platform-browser';
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  NavigationError,
  NavigationStart,
} from '@angular/router';
import { LayoutFile } from './models/settings.model';
import { LayoutService } from './services/layout.service';
import { SchoolmanagementService } from './services/schoolmanagement.service';
import {
  FeatureGroups,
  SchoolConfig,
  SchoolInfoBundle,
} from './models/school/schooladminitem.model';
//import { FeatureGroups } from './models/billing/BillingAccountInfo';
const BlockEmbed = Quill.import('blots/block/embed');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'impataapp';
  introJS = introJs();

  layoutFiles: LayoutFile[] = [];
  activeLayoutFiles: LayoutFile[] = [];
  private onInitDone = false;
  isOnline: boolean;
  isSchoolEnabled: boolean | null = null;
  logoUrl = '';
  constructor(
    public utilservice: UtilService,
    private router: Router,
    public schoolservice: SchoolmanagementService,
    private layoutService: LayoutService,
    private sanitizer: DomSanitizer
  ) {
    MediaBlot.blotName = 'media';
    MediaBlot.tagName = 'iframe';
    Quill.register(MediaBlot);

    this.hideContent();
    this.router.events.subscribe((event: any) => {
      this.routerEventHandler(event);
    });
  }

  async preloadCustomStyles() {
    const school: any = await this.schoolservice.getSchoolFromSubdomain();

    this.layoutFiles = await this.layoutService.getLayoutFiles(school.id);
    for (const layoutFile of this.layoutFiles) {
      layoutFile.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        layoutFile.fileurl
      );
    }
  }

  async ngOnInit() {
    //we don't want the application's default styles to display while we are loading the customer syles
    //so to prevent that, we hide the entire application until the styles have been retreived and the css FULLY loaded
    //to know if they are fully loaded, we may have to check if onload has fired on all the link tags
    try {
      this.utilservice.schoolInfoBundle = await this.utilservice.getStaticSchoolInfoBundle();        
      this.isSchoolEnabled = this.utilservice.schoolInfoBundle.schoolInfo.enabled;
      if (await this.utilservice.hasFeature(FeatureGroups.SITE_CUSTOMISATION)) {
        await this.preloadCustomStyles();
        this.setActiveLayoutFiles(this.router.url);

        await this.waitForAllStyleFilesToBeLoaded();

        this.showContent();
      }
      this.logoUrl = this.utilservice.schoolInfoBundle.schoolInfo.logoImg;
      //get online status
      this.updateOnlineStatus();
      window.addEventListener('online', this.updateOnlineStatus.bind(this));
      window.addEventListener('offline', this.updateOnlineStatus.bind(this));
      this.onInitDone = true;
    } catch (error) {
      debugger;
    }
  }

  hideContent() {
    const appRoot: any = document.getElementsByTagName('app-root')[0];
    appRoot.style.visibility = 'hidden';
    document.body.classList.add('body-loading');
  }

  showContent() {
    const appRoot: any = document.getElementsByTagName('app-root')[0];
    appRoot.style.visibility = 'visible';
    document.body.classList.remove('body-loading');
  }

  customCssLoaded(index: number) {
    console.log('loaded: ' + index);
    this.layoutFiles[index].loaded = true;
  }

  customCssErrored(index: number) {
    alert(
      `Error loading custom css file '${this.layoutFiles[index].filePath}'`
    );
    document.location.reload();
  }

  checkAllStyleFilesLoaded() {
    for (let i = 0; i < this.layoutFiles.length; i++) {
      if (!this.layoutFiles[i].loaded) {
        return false;
      }
    }
    return true;
  }

  waitForAllStyleFilesToBeLoaded(): Promise<void> {
    //await this.layoutService.sleep(2000);
    return new Promise((accept, reject) => {
      const check = () => {
        if (this.checkAllStyleFilesLoaded()) {
          accept();
        } else {
          setTimeout(check, 200);
        }
      };
      check();
    });
  }

  async routerEventHandler(event: Event) {
    if (event instanceof NavigationStart) {
      console.log('router event', event);

      //hide the content of the page until the proper css has been applied
      this.hideContent();
    } else if (event instanceof NavigationEnd) {
      const navigationEnd = event as NavigationEnd;

      // Hide progress spinner or progress bar
      //this.currentRoute = event.url;
      console.log('router event', event);

      //apply the proper css, then display the page
      const initDonePromise = new Promise<void>((accept, reject) => {
        const initDone = () => {
          if (this.onInitDone) {
            accept();
          } else {
            setTimeout(initDone, 200);
          }
        };
        initDone();
      });

      await initDonePromise;

      this.setActiveLayoutFiles(navigationEnd.urlAfterRedirects);

      await this.waitForAllStyleFilesToBeLoaded();

      this.showContent();
    } else if (event instanceof NavigationError) {
      this.showContent();
    }
  }

  private setActiveLayoutFiles(url: string) {
    this.activeLayoutFiles = [];
    for (const layoutFile of this.layoutFiles) {
      const regex = new RegExp(layoutFile.urlRegex);
      if (regex.test(url)) {
        this.activeLayoutFiles.push(layoutFile);
      }
    }
  }


  private updateOnlineStatus(): void {
    this.isOnline = window.navigator.onLine;
  }

}

export class MediaBlot extends BlockEmbed {
  static blotName;
  static tagName;
  static create(value) {
    //debugger;
    const node = super.create();

    node.setAttribute('src', value);
    //node.setAttribute('frameborder', '0');
    // node.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
    // node.setAttribute('allowtransparency', true);
    node.setAttribute('allowfullscreen', true);
    // node.setAttribute('scrolling', '0');
    //$(node).css('width', '100%');
    //node.setAttribute('height', '315px');

    node.setAttribute('class', 'mediaiframe');

    return node;
  }

  static value(node) {
    return node.dataset.id;
  }
}
